import React from 'react'
import GradientText from './Animations/GradientText'
import BlurText from './Animations/BlurText'
import AnimatedContent from './Animations/AnimatedContent'
import ShinyText from './Animations/ShinyText'

export default function About() {
    return (
        <div id='About' className='lg:px-[5vw] md:px-5 px-[5vw] md:mt-[10vw] mt-[15vw] relative'>
            <img src="/images/about.png" alt="" className='md:block hidden w-full' />
            <img src="/images/about-1.png" alt="" className='absolute w-[25vw] right-[10vw] top-[8vw] md:block hidden' />
            <div className='md:absolute static lg:left-[8vw] md:left-[5vw] top-[4vw]'>
                <div className='bg-black md:px-5 py-1 rounded-3xl w-fit md:mb-5 mb-3'>
                    <GradientText
                        colors={["#FF6972", "#D645D0", "#01B0DF",]}
                        animationSpeed={3}
                        showBorder={false}
                        className="font-semibold text-lg uppercase "
                    >
                        About vocal ai
                    </GradientText>
                </div>
                <BlurText
                    text="About the Project Vocal AI"
                    delay={150}
                    animateBy="words"
                    direction="top"
                    className="lg:text-4xl md:text-2xl text-2xl font-bold mb-5"
                />

                <div className='md:w-[700px]'>
                    <AnimatedContent
                        distance={150}
                        direction="horizontal"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <ShinyText text="Stay in control while the AI optimizes your portfolio 24/7

Let AI trade for you. Our system monitors top-performing assets, analyzes real-time data, and executes trades based on your custom settings—like risk level, trade limits, and capital allocation."
                            disabled={false} speed={3} className='custom-class' />
                    </AnimatedContent>
                </div>
                {/* bottom content  */}
                <div className='lg:pt-[8vw] md:pt-[2vw] pt-20'>
                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <img src="/images/coins.png" alt="" className='md:w-[17vw] w-full mb-3' />
                    </AnimatedContent>
                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <ShinyText text="market reached an all-time high"
                            disabled={false} speed={3} className='custom-class' />
                    </AnimatedContent>
                </div>
            </div>
            <div className='flex items-center md:flex-row flex-col gap-4 md:absolute static bottom-[0vw] right-[6vw] md:mt-0 mt-5'>
                <AnimatedContent
                    distance={150}
                    direction="vertical"
                    reverse={false}
                    config={{ tension: 80, friction: 20 }}
                    initialOpacity={0.2}
                    animateOpacity
                    scale={1.1}
                    threshold={0.2}
                >
                    <img src="/images/about-box-1.png" alt="" className='md:w-[28vw] w-full ' />
                </AnimatedContent>
                <AnimatedContent
                    distance={150}
                    direction="vertical"
                    reverse={false}
                    config={{ tension: 80, friction: 20 }}
                    initialOpacity={0.2}
                    animateOpacity
                    scale={1.1}
                    threshold={0.2}
                >
                    <img src="/images/about-box-2.png" alt="" className='md:w-[28vw] w-full ' />
                </AnimatedContent>


            </div>
        </div>
    )
}
